import { Timer } from "./common/utils/timer";

//------------------------------------------------------------------------------
export interface OWGamesEventsDelegate {
  onInfoUpdates(info: any);
  onNewEvents(e: any);
}

//------------------------------------------------------------------------------
export class OWGamesEvents {
  private _delegate: OWGamesEventsDelegate;
  private _featureRetries: number;
  private _requiredFeatures: string[];

  // This solves some async issues (with |setRequiredFeatures|).
  private _stopped: boolean = true;

  //----------------------------------------------------------------------------
  constructor(delegate: OWGamesEventsDelegate, 
              requiredFeatures: string[], 
              featureRetries: number = 10) {
    this._delegate = delegate;
    this._requiredFeatures = requiredFeatures;
    this._featureRetries = featureRetries;
  }

  //----------------------------------------------------------------------------
  public async getInfo(): Promise<any> {
    return new Promise((resolve) => {
      overwolf.games.events.getInfo(resolve);
    })
  }

  public async start(): Promise<boolean> {
    console.log(`[ow-game-events] START`);

    this._stopped = false;

    this.registerEvents();
    const result = await this.setRequiredFeatures();

    const { res, status } = await this.getInfo();

    if ( res && status === 'success' ) {
      this.onInfoUpdates({ info: res });
    }

    return result;
  }

  //----------------------------------------------------------------------------
  public stop(): void {
    console.log(`[ow-game-events] STOP`);

    this._stopped = true;

    this.unRegisterEvents();
  }


  //----------------------------------------------------------------------------
  private async setRequiredFeatures(): Promise<boolean> {
    let tries:number = 1,
        result;

    while ( tries <= this._featureRetries ) {
      result = await new Promise(resolve => {
        overwolf.games.events.setRequiredFeatures(
          this._requiredFeatures,
          resolve
        );
      })

      if ( result.status === 'success' ) {
        const json = JSON.stringify(result, null, 2);
        console.log(`setRequiredFeatures(): success: ${json}`);
        return (result.supportedFeatures.length > 0);
      }

      await Timer.wait(3000);

      if (this._stopped) {
        // This should solve any async side-effects we may have where we stop
        // while still in this loop
        console.info('setRequiredFeatures(): stopped while in loop');
        return false;
      }

      tries++;
    }

    const json = JSON.stringify(result, null, 2);
    console.warn(`setRequiredFeatures(): failure after ${tries} tries ${json}`);
    return false;
  }

  //----------------------------------------------------------------------------
  private registerEvents(): void {
    this.unRegisterEvents(); // Remove, potential previous listeners

    overwolf.games.events.onInfoUpdates2.addListener(this.onInfoUpdates);
    overwolf.games.events.onNewEvents.addListener(this.onNewEvents);
  }

  //----------------------------------------------------------------------------
  private unRegisterEvents(): void {
    overwolf.games.events.onInfoUpdates2.removeListener(this.onInfoUpdates);
    overwolf.games.events.onNewEvents.removeListener(this.onNewEvents);
  }

  //----------------------------------------------------------------------------
  private onInfoUpdates = (info: any): void => {
    this._delegate.onInfoUpdates(info.info);
  }

  //----------------------------------------------------------------------------
  private onNewEvents = (e: any): void => {
    this._delegate.onNewEvents(e);
  }  
}
